import React from 'react';
import { Container, Row, Col, Form } from 'shared-portal-component';
import { z } from 'zod';

import { FORM_LEN } from '@/constants';

export const userSchema = z.object({
  name: z.string().min(FORM_LEN, 'Name is required'),
  phone: z.string().min(FORM_LEN, 'Phone is required'),
  organization: z.string().optional(),
});

export const userFields = [
  { name: 'name', label: "User's Name", placeholder: 'Jane Doe', required: true, type: 'text' as const },
  { name: 'phone', label: "User's Phone", placeholder: '(555) 555-5555', required: true, type: 'text' as const },
  { name: 'organization', label: "Department / Organization", placeholder: 'Company name or dept.', required: false, type: 'text' as const },
];

interface UserFormProps {
  defaultValues?: Record<string, string>;
  onSubmit: (values: Record<string, string>) => void;
  submitText?: string;
}

const UserForm: React.FC<UserFormProps> = ({ defaultValues, onSubmit, submitText = 'Save Changes' }) => (
  <Container fluid>
    <Row spacing="none" justify="center">
      <Col>
        <Form
          schema={userSchema}
          fields={userFields}
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          submitText={submitText}
        />
      </Col>
    </Row>
  </Container>
);

export default UserForm;
